export const modalTypes = {
  SHOW_MODAL: "showModal",
  SAVE_SNAPSHOT: "SAVE_SNAPSHOT",
  CONFIRMATION: "CONFIRMATION",

  ADD_USER_TO_WORKSPACE: "ADD_USER_TO_WORKSPACE",
  ERROR: "ERROR",
  DELETE_WORKSPACE: "DELETE_WORKSPACE",
  WORKSPACE_RESERVED_LICENSES: "WORKSPACE_RESERVED_LICENSES",
  WORKSPACE_BANNER: "WORKSPACE_BANNER",
  ANONYMIZE_USERS: "ANONYMIZE_USERS",
  EDIT_PERMISSIONS: "EDIT_PERMISSIONS",
  EXPORT_REPORT: "EXPORT_REPORT",
  NEW_USER: "NEW_USER",
  EDIT_USER: "EDIT_USER",
  IMPORT_USERS: "IMPORT_USERS",
  EDIT_USER_AND_PERMISSIONS: "EDIT_USER_AND_PERMISSIONS",
  DICTIONARY_FOLDER_DOC_INFO: "DICTIONARY_FOLDER_DOC_INFO",
  ENABLE_SSO: "ENABLE_SSO",
  ENABLE_USERNAME_PASSWORD: "ENABLE_USERNAME_PASSWORD",
  ABOUT_VT_DOCS: "ABOUT_VT_DOCS",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  DICTIONARY_DOCUMENTS_AND_FOLDERS: "DICTIONARY_DOCUMENTS_AND_FOLDERS",
  INFO_BANNER: "INFO_BANNER",
  IMPORT_DICTIONARY: "IMPORT_DICTIONARY",
  TEXT_FIELD_MODAL: "TEXT_FIELD_MODAL",
  IMPORT_FILE: "IMPORT_FILE",
  CHANGE_DICTIONARY: "CHANGE_DICTIONARY",
  EXPORT_MULTIPLE_DOCS: "EXPORT_MULTIPLE_DOCS",
  EXPORT_CONTENT: "EXPORT_CONTENT",
  ANNOTATED_DOCUMENT: "ANNOTATED_DOCUMENT",
  SHRED_TO_EXCEL: "SHRED_TO_EXCEL",
  DISCOVERY_EXPORT_MULTIPLE_DOCS: "DISCOVERY_EXPORT_MULTIPLE_DOCS",
  RESET_DEFAULTS_THRESHOLDS: "RESET_DEFAULTS_THRESHOLDS",
  IGNORE_TERM_CONFIRM: "IGNORE_TERM_CONFIRM",
  CREATE_NEW_DICTIONARY: "CREATE_NEW_DICTIONARY",
  CREATE_NEW_CATEGORY: "CREATE_NEW_CATEGORY",
  SELECT_DOCUMENT: "SELECT_DOCUMENT",
};

export const snapshotLoadingTypes = {
  NOT_LOADING: "notLoading",
  INITIAL_LOADING: "initialLoading",
  LOAD_CHECKED_ITEMS: "loadCheckedItems",
  LOAD_SHOW_SELECTED: "loadShowSelected",
};

export const elements = {
  CONTENT: "content",
  BY_CONTENT_VIEW: "byContentView",
};

export const httpMethods = {
  GET: "get",
  DELETE: "delete",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
};

export const checkedTypes = {
  EMPTY: "empty",
  INDETERMINATE: "indeterminate",
  CHECKED: "checked",
};
